export const searchOptions = [
	{ value: 'fullname', label: 'Promoter  Name' },
	{ value: 'phone', label: 'Phone Number' },
	{ value: 'isActive', label: 'Active(0/1)' }
];
